import { ReactElement } from 'react';
import { IComponentHeaderLeftTextRightFields } from 'types/contentful';

import RichText from 'components/UI/Richtext';

export default function HeaderLeftTextRight({
  heading,
  text,
}: IComponentHeaderLeftTextRightFields): ReactElement {
  return (
    <section className="px-site-component">
      <div className="grid gap-8 lg:grid-cols-2 lg:gap-12 xl:gap-16 items-start">
        <div className="flex items-center">
          <h2 className="bordered-heading-richtext bh-header-left-text-right">
            <RichText
              document={heading}
              classNames="font-heading text-new-34 lg:text-4xl lg:leading-new-43 text-primary-actual richtext-font-inherit"
            />
          </h2>
        </div>

        <div className="text-left">
          <RichText document={text} classNames="text-lg text-primary-actual" />
        </div>
      </div>
    </section>
  );
}
